import Link from "next/link";
import { FC } from "react";

interface ButtonBaseProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  href?: string;
  prefixIcon?: FC<{ className?: string }>;
  suffixIcon?: FC<{ className?: string }>;
  className?: string;
}

const ButtonContent: FC<{
  text: string;
  prefixIcon?: FC<{ className?: string }>;
  suffixIcon?: FC<{ className?: string }>;
}> = ({ text, prefixIcon: PrefixIcon, suffixIcon: SuffixIcon }) => (
  <>
    <span className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity rounded-full"></span>
    {PrefixIcon && <PrefixIcon className="mr-2 h-5 w-5" />}
    {text}
    {SuffixIcon && <SuffixIcon className="mr-2 h-5 w-5" />}
  </>
);

export const ButtonBase: FC<ButtonBaseProps> = ({
  text,
  onClick,
  disabled,
  href,
  prefixIcon,
  suffixIcon,
  className,
}) => {
  const baseStyles =
    "flex items-center justify-center gap-2 px-4 lg:px-8 py-2 rounded-full relative group";
  const combinedStyles = `${baseStyles} ${className} ${
    disabled ? "cursor-not-allowed opacity-75" : ""
  }`;

  if (href) {
    return (
      <Link
        href={href}
        className={combinedStyles}
        onClick={onClick}
        aria-disabled={disabled}
      >
        <ButtonContent
          text={text}
          prefixIcon={prefixIcon}
          suffixIcon={suffixIcon}
        />
      </Link>
    );
  }

  return (
    <button className={combinedStyles} onClick={onClick} disabled={disabled}>
      <ButtonContent
        text={text}
        prefixIcon={prefixIcon}
        suffixIcon={suffixIcon}
      />
    </button>
  );
};
